module.exports = __webpack_public_path__ + "static/media/116 IWMP.ef7d0c32.pdf";